import type { HelpFile } from '../../types/help'
import { ValueListsTestIds } from '../../../testids/ValueListsTestIds'

export const valueListsHelp: HelpFile = {
  docPage: '/docs/schema/value-lists',
  texts: {
    [ValueListsTestIds.valueLists]: 'Value lists define ordered sets of lookup values used in dropdowns and validation rules.',
    [ValueListsTestIds.btnCreateValueList]: null,
    [ValueListsTestIds.colActive]: 'Inactive value lists are hidden from form pickers and cannot be selected.',
    [ValueListsTestIds.colDescription]: null,
    [ValueListsTestIds.colDisplayName]: null,
    [ValueListsTestIds.colName]: null,
    [ValueListsTestIds.inputVlDescription]: null,
    [ValueListsTestIds.inputVlDisplayName]: null,
    [ValueListsTestIds.inputVlName]: 'Internal identifier — used in API references and expressions; cannot be changed after creation.',
  },
}
